(() => {
  const normSize = value => {
    const text = String(value).trim();
    const child = text.match(/מידה\s*(\d+)\s*$/);
    return child ? child[1] : text.toUpperCase().replace('XXXL','3XL').replace('XXL','2XL');
  };
  window.PMConnectSizeGuide = (root, variants, strings) => {
    if(root.dataset.sizeBridgeReady) return;
    const frame = root.querySelector('[data-pm-size-frame]');
    const guide = root.querySelector('[data-pm-guide]');
    const opener = root.querySelector('[data-pm-guide-open]');
    const sizeField = root.querySelector('[data-pm-size-option]');
    const select = root.querySelector('[data-pm-size-select]');
    if(!frame || !guide || !opener || (!sizeField && !select)) return;
    root.dataset.sizeBridgeReady = 'true';
    const fields = [...root.querySelectorAll('[data-pm-option]')];
    function selectedOptions() {
      if(select) return variants.find(v => String(v.id) === select.value)?.options || [];
      const options = [];
      fields.forEach(field => {options[Number(field.dataset.pmOption)] = field.querySelector('input:checked')?.value;});
      return options;
    }
    function candidates() {
      const options = selectedOptions();
      const index = select ? 0 : Number(sizeField.dataset.pmOption);
      return variants.filter(v => v.available && v.options.every((value,i) => i === index || !options[i] || options[i] === value));
    }
    function configure() {
      const index = select ? 0 : Number(sizeField.dataset.pmOption);
      const options = selectedOptions();
      const sizes = variants.filter(v => v.options.every((value,i) => i === index || !options[i] || options[i] === value)).map(v => ({id:v.id,label:normSize(v.options[index]),available:v.available}));
      frame.contentWindow.postMessage({type:'pm-size-config',kind:root.dataset.pmMode,title:root.dataset.productTitle,sizes,whatsapp:(document.querySelector('a[href*="wa.me"]')?.href.match(/wa\.me\/(\d+)/)||[])[1]||''},'*');
    }
    opener.addEventListener('click', event => {
      event.preventDefault();
      guide.showModal();
      if(!frame.srcdoc) frame.srcdoc = window.PMSizeGuideHtml;
      else configure();
    });
    window.addEventListener('message', event => {
      if(event.source !== frame.contentWindow || !event.data) return;
      const data = event.data;
      if(data.type === 'pm-size-ready') configure();
      if(data.type === 'pm-size-close') guide.close();
      if(data.type === 'pm-size-pick') {
        const index = select ? 0 : Number(sizeField.dataset.pmOption);
        const match = candidates().find(v => normSize(v.options[index]) === normSize(data.size));
        if(!match) return;
        if(select) {
          select.value = String(match.id);
          select.dispatchEvent(new Event('change',{bubbles:true}));
        } else {
          const input = [...sizeField.querySelectorAll('input')].find(v => v.value === match.options[index]);
          if(!input) return;
          input.checked = true;
          input.dispatchEvent(new Event('change',{bubbles:true}));
        }
        guide.close();
      }
      if(data.type === 'pm-size-help') {
        const link = document.querySelector('a[href*="wa.me"],a[href*="api.whatsapp.com"]');
        if(link) link.click();
        else {
          guide.close();
          const status = root.querySelector('[data-pm-status]');
          if(status) status.textContent = strings.error || '';
        }
      }
    });
    guide.addEventListener('click',event => {if(event.target === guide) guide.close();});
    guide.addEventListener('close',() => opener.focus());
  };
  function initKids(root) {
    const data = root.querySelector('[data-pm-variants]');
    if(data) window.PMConnectSizeGuide(root,JSON.parse(data.textContent),JSON.parse(root.querySelector('[data-pm-size-strings]').textContent));
  }
  document.querySelectorAll('[data-pm-kids-sizing]').forEach(initKids);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-pm-kids-sizing]').forEach(initKids));
})();

